import React from "react"
import { InputGroup, Input, InputRightElement, Button } from '@chakra-ui/react'

interface Props {
  value?: string,
  onChange?: () => void,
  props: any,
  borderColor: string,
  border: string,
  focusBorderColor: string,
  disabled: boolean
}

export function PasswordInput({ 
  value, 
  onChange, 
  borderColor, 
  border, 
  focusBorderColor, 
  props,
  disabled 
}: Props) {
  const [show, setShow] = React.useState(false)
  const handleClick = () => setShow(!show)

  return (
    <InputGroup size='lg'>
      <Input
        disabled={disabled}
        border={border}
        value={value} onChange={onChange} pr='4.5rem'
        type={show ? 'text' : 'password'} bgColor='#1E1F22' 
        placeholder="**********" mt={1} 
        _placeholder={{ color: '#B5BAC1' }} color='#B5BAC1' 
        borderColor={borderColor} 
        focusBorderColor={focusBorderColor}
        _hover={{ outlineColor: 'transparent' }}
        {...props}
      />
      <InputRightElement width='5rem'>
        {!disabled && 
          <Button 
            border='1px' borderColor='#313338' 
            colorScheme='gray' mt={2} size='xs' 
            fontSize={10} onClick={handleClick}
          >
            {show ? 'Hide' : 'Show'}
          </Button>
        }
      </InputRightElement>
    </InputGroup>
  )
}